import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'
import HStack from 'components/atoms/stack/HStack'
import Text from "theme/Text";
import { StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'
import i18n from 'utils/i18n'
import { colorList } from 'utils/colors'
import FetchCachedParkingStatuses from 'utils/fetch/cached/FetchCachedParkingStatuses'

const ParkingStatuses = () => {
	
	const _parkingStatuses = useSelector( state => {
		return state.data[dataConstants.PARKING_STATUSES];
	} )
	
	useEffect( () => {
		FetchCachedParkingStatuses.reload()
	}, [] );
	
	if( _.isEmpty( _parkingStatuses ) ) {
		return null;
	}
	
	return (
		<HStack
			spacing={ 6 }>
			
			{ _.map( _parkingStatuses, status => {
				return (
					<ParkingStatus
						key={ `parking-status-`+ status.name }
						status={ status }
					/>
				);
			})}
		</HStack>
	)
}

const ParkingStatus = ({ status }) => {
	
	const statusComponent = useMemo( () => {
		const isFull = status.is_full === 'yes';
		
		if( isFull ) {
			return (
				<Text
					style={[ styles.itemStatus, styles.itemStatusFull ]}>
					
					{ i18n.t('parking_status.full') }
				</Text>
			)
		}
		
		return (
			<Text
				style={[ styles.itemStatus, styles.itemStatusFree ]}>
				
				{ i18n.t('parking_status.free') }
			</Text>
		)
	}, [ status ])
	
	return (
		<HStack
			style={ styles.item }>
		
			<Text style={ styles.itemText }>{ i18n.t('parking_status.label') }: </Text>
			{ statusComponent }
		</HStack>
	)
}

const styles = StyleSheet.create({
	item: {
		//backgroundColor: 'rgba( 57, 44, 61, 0.7 )',
		backgroundColor: colorList.WHITE.primary,
		borderWidth: 1,
		borderColor: colorList.GREY.light,
		padding: ThemedValues.marginHorizontal,
		borderRadius: ThemedValues.borderRadius,
	},
	itemText: {
		color: colorList.TEXT.primary,
	},
	
	itemStatus: {
		textTransform: 'uppercase',
	},
	itemStatusFree: {
		color: colorList.GREEN.primary
	},
	itemStatusFull: {
		color: colorList.RED.primary
	}
});


export default ParkingStatuses;
